import React from 'react';
import { Select } from 'antd';

import { Session } from 'state';

export type WhichMarkets = Session['which_markets'];

export const MARKETS_VIEW_OPTIONS: {
  value: WhichMarkets;
  label: string;
}[] = [
  { value: 0, label: 'Classic (0)' },
  { value: 1, label: 'All markets board (1)' },
  { value: 2, label: 'Split desk (2)' },
  { value: 3, label: 'Markets V4 (3)' },
  { value: 4, label: 'Markets V5 (4)' },
];

type Props = {
  value: WhichMarkets;
  disabled?: boolean;
  onChange: (value: WhichMarkets) => void;
};

const MarketsViewSelect: React.FC<Props> = ({
  value,
  disabled = false,
  onChange,
}) => (
  <Select<WhichMarkets>
    aria-label="Player Markets view"
    value={value}
    options={MARKETS_VIEW_OPTIONS}
    disabled={disabled}
    style={{ minWidth: 220 }}
    onChange={onChange}
  />
);

export default MarketsViewSelect;
